export function sanitizeTimeSeriesBars(bars) {
  const byTime = new Map();
  for (const bar of bars || []) {
    const time = Number(bar?.time ?? bar?.t);
    const open = Number(bar?.open ?? bar?.o);
    const high = Number(bar?.high ?? bar?.h);
    const low = Number(bar?.low ?? bar?.l);
    const close = Number(bar?.close ?? bar?.c);
    if (![time, open, high, low, close].every(Number.isFinite)) continue;
    byTime.set(time, {
      time,
      open,
      high,
      low,
      close,
    });
  }
  return Array.from(byTime.values()).sort((a, b) => a.time - b.time);
}
